import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCrossOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M24.96 5.626a1 1 0 1 1 1.414 1.414L17.414 16l8.96 8.96a1 1 0 1 1-1.414 1.414L16 17.414l-8.96 8.96a1 1 0 1 1-1.414-1.414l8.96-8.96-8.96-8.96A1 1 0 1 1 7.04 5.626l8.96 8.96z" /></svg>;
export default SvgIconCrossOutlined;